// extracted by mini-css-extract-plugin
export default {"navDropdown":"cRLcVLgK"};